export const ApiKeysColumns = [
    {
        displayName: 'Key ID',
        sortColumnName: 'keyId',
        dataType: 'string',
        dataKey: 'keyId',
        settings: { sort: true, filter: true, multiple: false },
    },
    {
        displayName: 'API Key',
        sortColumnName: 'key',
        dataType: 'string',
        dataKey: 'key',
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Created',
        sortColumnName: 'createdAt',
        dataType: 'date',
        dataKey: 'createdAt',
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Expires',
        sortColumnName: 'expiresAt',
        dataType: 'date',
        dataKey: 'expiresAt',
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Status',
        sortColumnName: 'isValid',
        dataType: 'indicator-chip',
        dataKey: 'isValid',
        converter: (isValid) =>
            isValid
                ? { label: { text: 'Active' }, value: 1, css: 'bg-green' }
                : { label: { text: 'Inactive' }, value: 0, css: 'bg-grey' },
        settings: { sort: true, filter: true, multiple: false },
    },
    {
        displayName: 'System',
        sortColumnName: 'systemName',
        dataType: 'string',
        dataKey: 'systemName',
        settings: { sort: true, filter: true, multiple: false },
    },
    {
        displayName: 'Created By',
        sortColumnName: 'createdByUserName',
        dataType: 'string',
        dataKey: 'createdByUserName',
        settings: { sort: true, filter: true, multiple: false },
    },
    {
        displayName: 'Actions',
        sortColumnName: 'actions',
        dataType: 'actions',
        dataKey: 'actions',
        settings: { sort: false, filter: false, multiple: false },
    },
];

export const ApiKeysFilters = {
    sorting: {
        sortByColumn: 'createdAt',
        sortByDescending: true,
    },
    pagination: {
        paginationEvent: () => {},
        paginationData: {
            pageNumber: 1,
            pageSize: 10,
            total: 0,
        },
        pageSizeOptions: [
            { value: 5, text: '5' },
            { value: 10, text: '10' },
            { value: 25, text: '25' },
            { value: 50, text: '50' },
            { value: 100, text: '100' },
        ],
        defaultPageSize: { value: 10, text: '10' },
    },
};

export const apiKeysTableConfig = {
    columns: ApiKeysColumns,
    filters: ApiKeysFilters,
};
